export default "/assets/chart.svg";